module.exports = __webpack_public_path__ + "static/img/alert.6f3764d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/alert.svg
// module id = a30e
// module chunks = 69